'use client';

import React, { useContext } from 'react';
import Link from 'next/link';

import { useTracking } from 'app/_tracking';
import { Button } from 'components/ui/button';
import { CommunityQuery } from 'generated/operations';
import { OWNER_ROUTES } from 'utils/routes';
import ApplyLoginContext from 'app/_context/ApplyLoginContext';

type CommunityFaceType = Extract<CommunityQuery['community'], any>;

type FaceJoinProps = {
  community: CommunityFaceType;
};

export default function FaceJoin({ community }: FaceJoinProps) {
  const { applyOrLogin } = useContext(ApplyLoginContext);
  const { trackEvent } = useTracking();

  return (
    <>
      <div className={'flex justify-center'}>
        {community.hasJoined ? (
          community.isAdmin ? (
            <Link href={OWNER_ROUTES.SPACE_SETTINGS.getPath(community.subdomain ?? '')}
                  target={'_blank'} className={'w-full'}>
              <Button
                variant={'nakedBrand'}
                className={'text-small w-full'}
              >
                Edit
              </Button>
            </Link>
          ) : (
            <Button
              variant={'primaryBrand'}
              disabled={true}
              className={'text-small w-full'}
            >
              Joined
            </Button>
          )
        ) : community.hasApplied ? (
          <Button
            variant={'primaryBrand'}
            disabled={true}
            className={'text-small w-full'}
          >
            Applied
          </Button>
        ) : !community.hasJoined ? (
          <Button
            variant={'primaryBrand'}
            className={'text-small w-full'}
            onClick={() => {
              trackEvent({ name: 'application_started' });
              applyOrLogin()
            }}
          >
            Join space
          </Button>
        ) : null}
      </div>
    </>
  );
}
